<div class="chat-dialog__backdrop" (click)="close()"></div>

<div class="chat-dialog chat-quick" role="dialog" aria-modal="true" aria-label="Quick Message">
  <header class="chat-dialog__header">
    <h3>Quick Message</h3>
    <button type="button" (click)="close()" aria-label="Close" [disabled]="store.quickMessageSending()"><i class="pi pi-times"></i></button>
  </header>

  <div class="chat-dialog__body">
    <p class="chat-quick__hint">
      <i class="pi pi-info-circle"></i>
      Sent as an individual message to each person picked below — not a group. Nobody sees who else got it.
    </p>

    <div class="chat-dialog__search">
      <i class="pi pi-search"></i>
      <input type="text" [ngModel]="search()" (ngModelChange)="search.set($event)" placeholder="Search people…" aria-label="Search people" />
    </div>

    <div class="chat-quick__list-card">
      <div class="chat-quick__select-all">
        <button type="button" (click)="toggleAll()" [disabled]="!people().length">
          {{ allSelected() ? 'Clear selection' : 'Select all (' + people().length + ')' }}
        </button>
        <span class="chat-quick__count-pill" [class.is-active]="!!selectedCount()">{{ selectedCount() }} selected</span>
      </div>

      <ul class="chat-dialog__people chat-quick__list">
        <li
          *ngFor="let person of filtered(); trackBy: trackByPerson"
          (click)="toggle(person)"
          [class.is-selected]="isSelected(person)"
          role="checkbox"
          [attr.aria-checked]="isSelected(person)">
          <span class="chat-dialog__check" [class.is-on]="isSelected(person)"><i class="pi pi-check" *ngIf="isSelected(person)"></i></span>
          <app-chat-avatar [name]="person.name" [avatar]="person.avatar_url" [status]="person.status" [size]="28"></app-chat-avatar>
          <span class="chat-quick__identity">
            <span class="chat-dialog__person-name">{{ person.name }}</span>
            <span class="chat-quick__status" [class.is-online]="person.status === 'online'">{{
              person.status === 'online' ? 'Online' : 'Offline'
            }}</span>
          </span>
        </li>
        <li class="chat-dialog__none" *ngIf="!filtered().length">No matching people.</li>
      </ul>
    </div>

    <label class="chat-quick__message">
      <span>Message</span>
      <textarea
        [(ngModel)]="body"
        rows="3"
        [maxlength]="maxLength"
        placeholder="Type a quick message…"
        [disabled]="store.quickMessageSending()"></textarea>
    </label>

    <p class="chat-quick__progress" *ngIf="store.quickMessageProgress() as progress">
      <i class="pi pi-spin pi-spinner"></i>
      Sending {{ progress.sent }} of {{ progress.total }}…
    </p>
  </div>

  <footer class="chat-dialog__footer chat-quick__footer">
    <span class="chat-quick__count">{{ selectedCount() ? selectedCount() + ' selected' : 'Pick at least one person' }}</span>
    <div class="chat-quick__actions">
      <button type="button" class="chat-quick__cancel" (click)="close()" [disabled]="store.quickMessageSending()">Cancel</button>
      <button type="button" class="chat-quick__send" (click)="send()" [disabled]="!selectedCount() || !body.trim() || store.quickMessageSending()">
        <i class="pi pi-spin pi-spinner" *ngIf="store.quickMessageSending()"></i>
        {{ store.quickMessageSending() ? 'Sending…' : 'Send' }}
      </button>
    </div>
  </footer>
</div>
